import { useDataChange } from 'Simple/Data.js'

export default function useDataOnChange(props) {
  let change = useDataChange({
    context: 'manual_action_executions',
    viewPath: props.viewPath,
  })

  return function onChange(value, fn) {
    let status = 'pending'
    if (value.status === 'skipped') {
      status = 'skipped'
    } else if (value.status === 'cancelled') {
      status = 'cancelled'
    } else if (isCompleted(value)) {
      status = 'completed'
    }

    change(inext => {
      let index = inext.findIndex(item => item.id === value.id)
      if (index > -1) {
        inext[index].status = status
        inext[index].data = value.data
        fn(iinext => {
          // update status in the current context
          iinext.status = status
        })
      }
    })
  }
}

function isCompleted(value) {
  switch (value.action_type) {
    case 'status_update':
      return isStatusUpdateCompleted(value)
    case 'task_insert':
      return isTaskInsertCompleted(value)
    case 'task_insert_new':
      return isNewTaskInsertCompleted(value)
    case 'check_requirements':
      // no user input so it is always valid
      return true
    case 'create_procedure_receivables':
      return isCreateClaimCompleted(value)
    default:
      return false
  }
}

function isStatusUpdateCompleted(value) {
  return value.data.new_status
}

function isNewTaskInsertCompleted(value) {
  return (
    value.data.new_task.title &&
    value.data.new_task.board_id &&
    value.data.new_task.stage_id &&
    (value.data.new_task.actions.length > 0
      ? value.data.new_task.actions[0].document_template_id !== null
      : true)
  )
}

function isTaskInsertCompleted(value) {
  return value.data.task?.title && value.data.task?.task_basket_id
}

function isCreateClaimCompleted(value) {
  if (
    value.data.claim?.charges?.length &&
    (!value.data.claim.payment_account ||
      value.data.claim.charges.some(charge => !charge.insurance_code_id) ||
      value.data.claim.charges.some(charge => !charge.type_id))
  ) {
    return false
  }

  if (
    value.data.invoice?.charges?.length &&
    (!value.data.invoice.payment_account ||
      value.data.invoice.charges.some(charge => !charge.type_id))
  ) {
    return false
  }

  return true
}
